"use client"
import styled from "styled-components";
import {Col, Container, Row, Tab, Tabs} from "react-bootstrap";
import Select, {components} from "react-select";
import React, {useEffect, useState} from "react";
import {hover, softWhite, text, white, White} from "@/styles/globalStyleVars";
import SingleMedia from "@/components/media/SingleMedia";
import {usePathname} from "next/navigation";
import {getApiHUB, getMedia} from "@/api";
import SelectField from "@/components/common/SelectField";

const MediaListing = ({data, category}) => {

    const pathname = usePathname();
    const [offset, setOffset] = useState(115);
    const [dataAll, setDataAll] = useState(data);
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {

        const handleResize = () => {
            setOffset(document.querySelector('.container').offsetLeft);
        };

        window.addEventListener('load', handleResize);
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('load', handleResize);
            window.removeEventListener('resize', handleResize);
        };
    }, [pathname]);
    const customStyles = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: "all .2s ease",
            // transform: state.selectProps.menuIsOpen && "rotate(180deg)"
        }),
        option: (provided, state) => ({
            ...provided,
            borderRadius: 0,
            color: state.isSelected ? `${hover}` : '#221F1F',
            backgroundColor: state.isSelected ? `rgba(232, 231, 231, 0.6)` : '#FFF',
            margin: 0,
            fontSize: 14,
            cursor: 'pointer',
            paddingLeft: 10,
            paddingRight: 10,
            fontWeight: state.isSelected ? 600 : 400,
            "&:hover": {
                backgroundColor: `rgba(232, 231, 231, 0.8)`,
                color: '#FFF',
                cursor: 'pointer'
            },

        }),
        menu: (provided, state) => ({
            ...provided,
            color: '#FFF',
            backgroundColor: state.isSelected ? `${hover}` : 'rgba(255,255,255,0)',
            margin: 0,
            borderRadius: 0,
            fontSize: 14,
            zIndex: 10
            // width: 200,
        }),
        menuList: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? `${hover}` : '#FFF',
            borderRadius: 0,
            fontWeight: '400',
            color: '#FFF',
            // fontSize: 14,
        }),

    };

    const options = [
        {value: '', label: 'All'}
    ];

    const CaretDownIcon = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="7.414" viewBox="0 0 13.414 7.414">
            <g id="Group_15659" data-name="Group 15659" transform="translate(1479.207 -192.793) rotate(90)">
                <line id="Line_3883" data-name="Line 3883" x2="6" y2="6" transform="translate(193.5 1466.5)" fill="none"
                      stroke="#FFFFFF" strokeLinecap="round" strokeWidth="1"/>
                <line id="Line_3884" data-name="Line 3884" y1="6" x2="6" transform="translate(193.5 1472.5)" fill="none"
                      stroke="#FFFFFF" strokeLinecap="round" strokeWidth="1"/>
            </g>
        </svg>;
    };
    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <CaretDownIcon/>
            </components.DropdownIndicator>
        );
    };

    const mergedOptions = options.concat(category?.map(item => ({
        value: item.id,
        label: item.title
    })));



    const handleClick = async (param, category,index) => {

        try {
            const getHomeData = await getMedia(param);
            setDataAll(getHomeData)
            setActiveIndex(index);
        } catch (error) {
            setDataAll(null)

        }
    };

    const handleSelect = async (param) => {
        try {
            const getHomeData = await getMedia(param?.value);
            setDataAll(getHomeData)
        } catch (error) {
            setDataAll(null)
        }
    };



    return (
        <StyledMediaListing className='media-listing pb-200' offset={offset} >
            <Container >
                <Row className={'media-listing__filter'}>
                    <Col>
                        <div className="media-listing__filter__desktop">
                            <ul className={'media-cat-list'}>
                                <li  key={0}><a href="javascript:void(0)" className={0 === activeIndex ? 'active' : ''}   onClick={() => handleClick('','',0)} >All</a></li>
                                {
                                    category && category?.length > 0 &&
                                    category?.map((e, index) => {
                                        return (
                                            <li key={index+1}><a href="javascript:void(0)"  className={index+1 === activeIndex ? 'active' : ''} onClick={() => handleClick(e?.id, e?.label,  index+1)}>{e?.title}</a></li>
                                        )
                                    })
                                }

                            </ul>
                        </div>

                        <div className="media-listing__filter__mobile">
                            <SelectField  selection={mergedOptions} background={'transparent'} defaultValue={mergedOptions?.[0]?.value}  onChange={(e) => handleSelect(e)} color={'#888888'} border={text} placeholder={'All'}/>
                        </div>
                    </Col>
                </Row>
                <Row className={'media-listing__wrap'}>


                    {
                        dataAll?.data && dataAll?.data?.length > 0 ?
                        dataAll?.data?.map((e, index) => {



                            var date = new Date(e?.data?.date);

                            // Extract day, month, and year
                            var day = date.getDate();
                            var month = date.toLocaleString('default', {month: 'long'});
                            var year = date.getFullYear();

                            return (
                                <Col key={index} md={4}>
                                    <SingleMedia
                                        cat={e?.category?.title}
                                        title={e?.data?.title}
                                        img={e?.images?.list?.[0]?.full_path}
                                        link={`/news-events/${e?.data?.slug}`}
                                        date={month+' '+day+', '+year}
                                    />
                                </Col>
                            )
                        }) :

                            <Col>
                                <h4>No News & Events Found</h4>
                            </Col>
                    }


                </Row>


            </Container>
        </StyledMediaListing>
    );
};

const StyledMediaListing = styled.section`
    padding-top: 60px;
    background-color: ${softWhite};

    .filter__control{
        border-color: ${text};
    }
    .media-listing__wrap{
        margin-top: 80px;
    }
    .media-listing__filter {
        .media-cat-list {
            display: flex;
            gap: 30px;

            li {
                a {
                    background-color: white;
                    display: block;
                    padding: 15px 30px;
                    width: 100%;
                    height: 100%;
                    color: ${text};
                    transition: 0.7s all ease;
                    border-radius: 50px;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: -0.16px;
                    font-weight: 400;

                    &.active {
                        color: #FFF;
                        background: ${hover};
                    }

                    &:hover {
                        background: ${hover};
                        color: ${white} !important;
                    }
                }

            }
        }
    }
    .col-md-4 {
        margin-bottom: 40px;

    }

    .media-listing__filter__desktop {
        @media (max-width: 767px) {
            display: none;
        }
    }

    .media-listing__filter__mobile {
        display: none;
        @media (max-width: 767px) {
            display: block;
        }
    }

    @media (max-width: 767px) {
        margin-top: 0;
        padding-left: 0;

    }


    @media (max-width: 767px) {
        padding-top: 40px;
    }



    @media (max-width: 991px) {
        .col-md-4 {
            min-width: 50%;
        }

    }

    @media (max-width: 768px) {
        .col-md-4 {
            min-width: 100%;
        }



    }



    @media (max-width: 767px) {
        padding-left: 15px;
        padding-right: 15px;
    }

`;
export default React.memo(MediaListing);